"use client";
import { microAnimation as n } from "@foundit/micro-animations";
import { useEffect as i } from "react";
const m = (o, t) => {
  i(() => {
    if (!o)
      return;
    n({
      element: o,
      transformInit: { opacity: 0 },
      transformEnd: { opacity: 1 },
      duration: t === "dropdown" ? 0 : 200
    });
  }, [o]);
};
export {
  m as usePopperTransitions
};
